// Reasons for the Hidden Prime Challenge (Sender + Receiver share this list).
// One "custom" slot lets the Sender enter free-text.

export const PRIME_REASONS = [
  { id: "attractiveness", label: "Attractiveness" },
  { id: "talent", label: "Talent" },
  { id: "personality", label: "Personality" },
  { id: "fame", label: "Fame / Status" },
  { id: "athletic", label: "Athletic Ability" },
  { id: "intelligence", label: "Intelligence" },
  { id: "humor", label: "Humor" },
  { id: "style", label: "Style" },
  { id: "nostalgia", label: "Nostalgia" },
  { id: "preference", label: "Personal Preference" },
  { id: "custom", label: "Other / Custom" },
];

export const primeReasonLabel = (id) =>
  PRIME_REASONS.find((r) => r.id === id)?.label || id;
